import { Css_Text_16_24_tw } from '@dreamstack/feature-components/src/layout/Texts'
import { cn } from '@dreamstack/util'
import { Switch } from '@headlessui/react'

const boldClass = 'font-semibold'

interface SimpleSwitchProps {
  checked: boolean
  setChecked: (checked: boolean) => void
  label: string
  description?: string
  grayDescription?: boolean
  disabled?: boolean
  nonBoldLabel?: boolean
  labelCss?: any[] // retained but unused (legacy prop)
}

export const SimpleSwitch = (props: SimpleSwitchProps) => {
  const { checked, setChecked, disabled, label, nonBoldLabel, description } =
    props

  return (
    <Switch.Group>
      <div className="flex gap-x-px-20 items-center">
        <Switch
          checked={checked}
          onChange={setChecked}
          disabled={disabled}
          className={`w-[43px] relative inline-flex h-[24px] w-[43px] flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 ${
            checked ? 'bg-accentroLightGreen-full' : 'bg-accentroGray-300'
          }`}
        >
          <span
            className={`pointer-events-none inline-block h-[20px] w-[20px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out ${
              checked ? 'translate-x-[19px]' : 'translate-x-0'
            }`}
          />
        </Switch>
        <div>
          {nonBoldLabel ? (
            <Switch.Label
              /* mimic Css_Text_16_24_tw */ className={cn(
                'mr-4',
                Css_Text_16_24_tw
              )}
            >
              {label}
            </Switch.Label>
          ) : (
            <span className={boldClass}>
              <Switch.Label className="mr-4">{label}</Switch.Label>
            </span>
          )}
          {description && (
            <Switch.Description
              className={props.grayDescription ? 'text-accentroGray-500' : ''}
            >
              {description}
            </Switch.Description>
          )}
        </div>
      </div>
    </Switch.Group>
  )
}
